<template>
  <div style="text-align: center;">
    <h1>Not Found!</h1>
    <p>
      <a href="/">Go home?</a>
    </p>
  </div>
</template>

<script>
  export default {
    name: 'PageNotFound',
  };
</script>
